<template>
  <!-- 选择编辑服务商，列表 -->
  <el-dialog title="服务商信息"
             :visible.sync="dialogOperatorInfo"
             :showDialogOperatorInfo="showDialogOperatorInfo"
             @close="closeOperatorInfoDialog()"
             @open="openOperatorInfoDialog()">
    <el-radio-group size="mini"
                    style="padding-left: 20px; margin-bottom: 40px"
                    @change="selectOperatorModel"
                    v-model="select_operator_model">
      <el-radio-button label="1">添加服务商</el-radio-button>
      <el-radio-button label="2">选择服务商</el-radio-button>
    </el-radio-group>
    <!-- 选择服务商 -->
    <div v-show="select_operator_visable">
      <el-table :data="operatorDataList"
                style="width: 100%">
        <!-- 产品名称 -->
        <el-table-column width="90%"
                         label="服务商列表"
                         prop="spu_name">
          <template slot-scope="operator_item">
            <div>
              <div id="spu_avata_area">
                <img style="height: 100%; weight: 100%"
                     :src="operator_item.row.operator_avatar"
                     alt
                     onerror="this.src='https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png'" />
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="spu_name">
          <template slot-scope="product_title">
            <span style="margin-right: 20px">{{
              product_title.row.operator_name
            }}</span>
            <el-tag effect="plain"
                    style="margin-right: 10px"
                    size="mini"
                    v-for="(item, index) in product_title.row.dest_name"
                    :key="index">{{ item }}</el-tag>
          </template>
        </el-table-column>
        <!-- 列表搜索 -->
        <el-table-column width="140%"
                         align="right">
          <template slot="header"
                    slot-scope="searchProduct">
            <el-input v-model="search"
                      size="mini"
                      @change="searchProduct"
                      placeholder="输入关键字搜索" />
          </template>
          <template slot-scope="selectOperator">
            <el-button size="mini"
                       @click="choiceProduct(selectOperator.$index, selectOperator.row)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 添加服务商 -->
    <div v-show="add_operator_visable"
         id="product_intor_editor_operator">
      <el-form :label-position="labelPosition"
               label-width="120px"
               :model="formOperatorInfo">
        <el-form-item label="商家logo">
          <el-upload class="avatar-uploader"
                     :name="file_name"
                     :action="$ip + '/add_image?key_name=operator_image'"
                     :show-file-list="false"
                     :with-credentials="true"
                     :on-success="handleAvatarSuccess"
                     :before-upload="beforeAvatarUpload"
                     accept=".jpg, .jpeg, .png, .gif">
            <img v-if="imageUrl"
                 :src="imageUrl"
                 class="avatar" />
            <i v-else
               class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="服务名称">
          <el-input style="width: 200px"
                    size="mini"
                    v-model="formOperatorInfo.name"></el-input>
        </el-form-item>
        <el-form-item label="当地/英文名称">
          <el-input style="width: 200px"
                    size="mini"
                    v-model="formOperatorInfo.loc_name"></el-input>
        </el-form-item>
        <el-form-item label="服务商所在地">
          <el-cascader style="width: 200px"
                       size="mini"
                       :show-all-levels="false"
                       v-model="selectDests"
                       :options="option"
                       @change="handleChoice"
                       :props="defaultProp"
                       clearable
                       filterable></el-cascader>
        </el-form-item>
        <el-form-item label="地址">
          <el-input style="width: 300px"
                    type="textarea"
                    size="mini"
                    v-model="formOperatorInfo.address"></el-input>
        </el-form-item>
        <el-form-item label="联系人">
          <el-input style="width: 200px"
                    size="mini"
                    v-model="formOperatorInfo.manager"></el-input>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input style="width: 200px"
                    size="mini"
                    v-model="formOperatorInfo.mobile"></el-input>
        </el-form-item>
        <el-form-item label="介绍">
          <el-input style="width: 300px"
                    type="textarea"
                    size="mini"
                    v-model="formOperatorInfo.introduce"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           style="text-align: center">
        <el-button size="mini"
                   @click="cancelAdditionForm('additionDialog')">取 消</el-button>
        <el-button size="mini"
                   type="primary"
                   @click="confirmAdditionAdd">添 加</el-button>
      </div>
    </div>
    <!-- 按钮 -->
  </el-dialog>
</template>

<script>
import Editor from '../common/editor/editorV1'
export default {
  name: 'product_operator',
  components: {
    'editor-area': Editor,
  },
  data() {
    return {
      select_operator_model: this.defaultSelector,
      select_operator_visable: false,
      add_operator_visable: true,
      operatorDataList: [], // 服务商列表数据
      search: '', // 服务商列表搜索
      dialogOperatorInfo: this.showDialogOperatorInfo,
      labelPosition: 'right',
      formOperatorInfo: {
        id: '',
        logo: '',
        name: '',
        loc_name: '',
        dest: '',
        address: '',
        manager: '',
        mobile: '',
        introduce: '',
      },
      file_name: 'image',
      selectDests: [], // 绑定对应选项的value值
      option: [], // 目的地可选项
      defaultProp: {
        // 联系选择器的属性，比如是否可以多选等
        multiple: true, //是否多选
        checkStrictly: true, // 是否严格的遵守父子节点不互相关联
        label: 'loc_name', // 指定选项标签为选项对象的某个属性值
        value: 'loc_id', // 指定选项的值为选项对象的某个属性值
        children: 'children', // 指定选项的子选项为选项对象的某个属性值
      },
      imageUrl: '', // 绑定后端图片的文件名称
      image_url: '', // 主图链接
    }
  },
  props: {
    imageUrlDefault: {
      type: String,
      default: '',
    },
    defaultSelector: {
      type: Number,
      default: 1,
    },
    showDialogOperatorInfo: { type: Boolean, default: false },
    spu_id: Number,
  },
  watch: {
    showDialogOperatorInfo: {
      immediate: true,
      handler(showDialogOperatorInfo) {
        // console.log(`watch new vlaue:${this.showDialogOperatorInfo}`);
        this.dialogOperatorInfo = this.showDialogOperatorInfo
      },
    },
  },
  created() {
    this.loadDest()
  },
  mounted() {
    this.selectOperatorModel()
  },
  methods: {
    // 选择服务商
    selectOperatorModel() {
      // console.log(this.select_operator_model);
      if (this.select_operator_model == 1) {
        this.select_operator_visable = false
        this.add_operator_visable = true
      } else if (this.select_operator_model == 2) {
        // 选择服务商
        this.select_operator_visable = true
        this.add_operator_visable = false
        // 获取服务商列表
        this.$http.get(`/product/get_operator_list`).then((res) => {
          const { data, errno, errmsg } = res.data
          this.operatorDataList = data
        })
      }
    },

    // 确认 选择 某个服务商
    choiceProduct(index, operator) {
      // 发送事件给父组件
      this.$emit('choiceProductOperator', index, operator)
      //
    },
    // 打开对话框
    openOperatorInfoDialog() {},
    // 提交
    confirmAdditionAdd() {
      this.formOperatorInfo.logo = this.image_url
      this.formOperatorInfo.new_dest = this.selectDests
      this.formOperatorInfo.spu_id = this.spu_id
      this.$emit('confirmAddOperator', this.formOperatorInfo)
    },
    // 取消 关闭对话框
    cancelAdditionForm() {
      this.showDialogOperatorInfo = false
    },
    // 获取 目的地信息
    loadDest() {
      this.$http.get('/get_dest_level').then((res) => {
        this.option = res.data.data
      })
    },
    handleChoice() {},
    closeOperatorInfoDialog() {
      this.$emit('update:showDialogOperatorInfo', false)
      // this.dialogOperatioInfo = false;
    },
    // 上传文件前 的 钩子 函数
    beforeAvatarUpload(file) {
      const isFORMAT =
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/gif'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isFORMAT) {
        this.$message.error('上传头像图片只能是 JPG/png/gif 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      // console.log(file);
      return isFORMAT && isLt2M
    },
    // 上传成功时的钩子函数，将返回值添加到页面中
    handleAvatarSuccess(res, file) {
      // console.log(res.data.image_url);
      this.image_url = res.data.image_url
      // 让图片可以展示在前端
      this.imageUrl = URL.createObjectURL(file.raw)
      // 赋值链接
      this.formOperatorInfo.logo = this.image_url
    },
  },
}
</script>

<style>
#spu_avata_area {
  height: 40px;
  width: 40px;
}
</style>